import { render, staticRenderFns } from "./ReopenRequestModal.vue?vue&type=template&id=58f281ce&scoped=true"
import script from "./ReopenRequestModal.vue?vue&type=script&lang=js"
export * from "./ReopenRequestModal.vue?vue&type=script&lang=js"
import style0 from "./ReopenRequestModal.vue?vue&type=style&index=0&id=58f281ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f281ce",
  null
  
)

export default component.exports